
export default {
  props: {
    blok: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      leftText: null,
      rightText: null,
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.parseStatNumber()
      this.initAnim()
    })
  },
  methods: {
    parseStatNumber() {
      // number value coming in from SB ex. '(4)B+'
      // we need to extract the number from the text to animate
      const number = this.blok.number.match(/\((.*)\)/i)
      // parse text before and after stat number
      const [leftText, rightText] = this.blok.number
        .replace(/\s*(?:\[[^\]]*\]|\([^)]*\))\s*/g, '|')
        .split('|')

      if (number) this.number = number[1]
      if (leftText) this.leftText = leftText
      if (rightText) this.rightText = rightText
    },
    initAnim() {
      // scope selector
      const q = this.$gsap.utils.selector(this.$el)

      const tl = this.$gsap.timeline({
        scrollTrigger: {
          trigger: this.$refs.container,
          start: 'center center',
          // markers: true,
        },
      })

      tl.to(q('.stat-num'), {
        duration: 1.5,
        innerText: this.number,
        snap: 'innerText',
      })
    },
  },
}
